// src/utils/processPolyfill.js
/**
 * Process polyfill utility
 * Ensures 'process' and 'process.env' are available in browser environments
 * This should be imported at the very beginning of your entry file (index.js)
 */

// Define default environment variables
const defaultEnv = {
  NODE_ENV: 'development',
  PUBLIC_URL: '',
  REACT_APP_API_BASE_URL: 'http://localhost:8081',
  REACT_APP_USE_V2_PAGINATION: 'true',
  REACT_APP_V2_PRODUCTS: 'true',
  REACT_APP_V2_SEARCH: 'true',
  REACT_APP_V2_CATEGORY_COUNTRIES: 'true',
  REACT_APP_V2_CATEGORY_SUBCATEGORY_COUNTRIES: 'true',
  REACT_APP_V2_LOVED_PRODUCTS: 'true',
  REACT_APP_PAGINATION_LIMIT: '20',
  REACT_APP_CACHE_PAGES: '5',
  REACT_APP_DEBUG_PAGINATION: 'false',
  REACT_APP_DEBUG_CACHE: 'false',
  REACT_APP_DEBUG_PERFORMANCE: 'true',
  REACT_APP_USE_MOCK_PAGINATION: 'true',
  REACT_APP_MOCK_SMALL_DATASETS: 'true',
  REACT_APP_EMAILJS_SERVICE_ID: 'service_jdtgytb',
  REACT_APP_EMAILJS_TEMPLATE_ID: 'template_dq0x1uk',
  REACT_APP_EMAILJS_UNSUBSCRIBE_TEMPLATE_ID: 'template_dq0x1uk',
  REACT_APP_EMAILJS_PUBLIC_KEY: 'LgEdFbhSM5JXRumaX',
  REACT_APP_ANALYTICS_ENDPOINT: 'https://your-analytics-api.com/track',
  SKIP_PREFLIGHT_CHECK: 'true',
  TSC_COMPILE_ON_ERROR: 'true',
  REACT_APP_DISABLE_TYPESCRIPT_PLUGIN: 'true',
  REACT_APP_USE_MOCK_DATA: 'false'
};

// Safely get the global object (works in browser, Node.js, and Web Workers)
const getGlobalObject = () => {
  if (typeof window !== 'undefined') return window;
  if (typeof global !== 'undefined') return global;
  // Remove reference to 'self' to fix ESLint warning
  return {};
};

// Get the global object
const globalObj = getGlobalObject();

const existingProcessEnv =
  typeof process !== 'undefined' && process && process.env
    ? process.env
    : globalObj.process && globalObj.process.env
    ? globalObj.process.env
    : {};

// Create a safe process object with default values
const safeProcess = {
  env: { ...defaultEnv, ...existingProcessEnv }
};

// Add process to global object if needed
if (typeof globalObj.process === 'undefined') {
  globalObj.process = safeProcess;
} 
// If process exists but env doesn't, add env
else if (typeof globalObj.process.env === 'undefined') {
  globalObj.process.env = { ...defaultEnv, ...existingProcessEnv };
}
// If both exist, ensure default values are present
else {
  globalObj.process.env = {
    ...defaultEnv,
    ...existingProcessEnv,
    ...globalObj.process.env
  };
}

// Export for convenience
export const processEnv = globalObj.process.env;

export default globalObj.process;